import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { memo } from 'react';
import {useTranslation} from 'react-i18next';

function CounterDelayed(props) {
  const {t} = useTranslation('navigation');

  return (
    <Paper
      className='justify-center rounded-none'
      id='delayed'
      style={{
        cursor: 'pointer',
        backgroundColor: '#000000',
        border: '3px solid #edca33',
      }}
    >
      <div className='flex items-center'>
        <Typography className='text-16 px-16 font-Regular ' color='#000000'></Typography>
      </div>
      <div className='text-center '>
        <Typography className='text-56 font-bold text-white '>{props.counter}</Typography>
        <Typography className='text-16 text-yellow-800 font-Regular'>{t('JOBS_DELAYED')}</Typography>

        <Typography className='text-16 text-white font-Regular'>
          {t('TICKET_COUNT')}: {props.tickets}
        </Typography>
      </div>
    </Paper>
  );
}

export default memo(CounterDelayed);
